export const HANDLE_LOADING = 'HANDLE_LOADING';
export const ADD_MODULE = 'ADD_MODULE';
export const GET_ERRORS = 'GET_ERRORS';
export const GET_MODULE = 'GET_MODULE';
export const ADD_MODULE_TO_COURSE = 'ADD_MODULE_TO_COURSE';
